import { slide } from '/../citeo-semantic/assets/slider'

/*
* INITIALIZATION FUNCTION
*/

const initialize = () => {
    // Class name activating the slider code, needs to be a parent of the actual slider
    const sliderTrigger = document.querySelectorAll('.query-slider')

    sliderTrigger.forEach(slider => {

        const sliderWrap = slider.querySelector('.slider-wrap')
            
        if( sliderWrap ) {

            const controlsWrap = slider.querySelector('.slider-controls')
            const stepperWrap = slider.querySelector('.stepper-wrap')

            const   isInfinite = false,
                    isDraggable = true,
                    step = 1,
                    hasStepper = false,
                    stepperType = null,
                    isAuto = false,
                    isRandom = false

            const sliderParams = {
                isInfinite: isInfinite,
                isDraggable: isDraggable,
                step: step,
                stepper: {
                    hasStepper: hasStepper,
                    controlStepper: stepperWrap,
                    stepperType: stepperType
                },
                autoParams: {
                    isAuto: isAuto
                },
                isRandom: isRandom
            }

            slide(sliderWrap, controlsWrap, sliderParams);

        } else { 
            console.warn('No slider found in this page.');
        }
    
    });
};
initialize();